import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "@phosphor-icons/react";
import { progressEvent, BOOK_LABEL } from "../lib/progress";

export default function IllustrationReviewBlock({ heroLabel, heroValue, heroSuffix }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { progressEvent("calc_complete", { via: "review_block" }); io.disconnect(); }
    }, { threshold: 0.5 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div ref={ref} data-testid="calc-review-block" className="relative mt-10 border border-exodus-gold bg-exodus-elevated p-7 md:p-10">
      <div className="absolute top-0 left-0 w-16 h-1 bg-exodus-gold" />
      {heroValue && (
        <p className="text-xs text-exodus-muted">{heroLabel}: <span data-testid="calc-review-hero" className="font-display text-2xl gold-text ml-1">{heroValue}{heroSuffix}</span> <span className="text-[10px]">(estimate)</span></p>
      )}
      <h3 className="font-display text-3xl md:text-4xl mt-4 leading-tight">Want real numbers instead of estimates?</h3>
      <ul className="mt-6 space-y-3 text-sm">
        {["Carrier-specific illustration (not a generic example)", "Assumptions explained in plain English", "A clear next step (or a clear “not yet”)"].map((b) => (
          <li key={b} className="flex gap-3"><Check size={16} weight="bold" className="text-exodus-gold shrink-0 mt-0.5" />{b}</li>
        ))}
      </ul>
      <Link data-testid="calc-book-review" to="/reserve" onClick={() => progressEvent("book_click")} className="btn-gold mt-8 w-full sm:w-auto justify-center">
        {BOOK_LABEL} <ArrowRight size={16} weight="bold" />
      </Link>
      <p data-testid="calc-book-microcopy" className="text-xs text-exodus-muted mt-3">$100 refundable booking fee. 15–25 minutes. No sales pressure.</p>
    </div>
  );
}
